
(function(){
const anims={};
const RSSC=(()=>{try{return JSON.parse(document.querySelector('.rss [data-rss-copy]').textContent)}catch(e){return {}}})();
const TT=k=>RSSC[k]||'', TF=(k,n)=>TT(k).split('#N#').join(n);
const A=(id,def)=>anims[id]=def;
const lerp=(a,b,t)=>a+(b-a)*t, clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
const ease=t=>t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2;
const easeOut=t=>1-Math.pow(1-t,3);
function rng(seed){let a=seed>>>0;return()=>{a|=0;a=a+0x6D2B79F5|0;let t=Math.imul(a^a>>>15,1|a);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296}}
const C={ink:'#E8EAED',dim:'#8F949D',line:'#2A3037',teal:'#5ECDBD',red:'#EA5D59',yellow:'#FED766',bg:'#0A0D10'};
function txt(x,s,t,px,col,align,weight){x.save();x.font=(weight||600)+' '+px+"px 'Mona Sans',system-ui,sans-serif";x.fillStyle=col;x.textAlign=align||'left';x.fillText(s,...t);x.restore()}
function rr(x,a,b,w,h,r){x.beginPath();x.moveTo(a+r,b);x.arcTo(a+w,b,a+w,b+h,r);x.arcTo(a+w,b+h,a,b+h,r);x.arcTo(a,b+h,a,b,r);x.arcTo(a,b,a+w,b,r);x.closePath()}
function gauss(x,m,s){return Math.exp(-0.5*Math.pow((x-m)/s,2))/(s*Math.sqrt(2*Math.PI))}
function unitArea(xs,ys){let a=0;for(let i=1;i<xs.length;i++)a+=(ys[i]+ys[i-1])/2*(xs[i]-xs[i-1]);return ys.map(v=>v/a)}
function psdCount(xs,fineW,mainMu,fineMu){return xs.map(x=>fineW*gauss(x,fineMu,0.20)+(1-fineW)*gauss(x,mainMu,0.135));}
function weightBy(xs,ys,pow){return xs.map((x,i)=>ys[i]*Math.pow(Math.pow(10,x),pow))}
/* ---------- 1 · cut vs crush ---------- */
A('fines',{
 init(st){const r=rng(7);st.frag=[];st.fine=[];
  for(let i=0;i<34;i++)st.frag.push({x:(r()-.5)*54,y:(r()-.5)*30,s:3+r()*11,a:r()*6.3,vx:(r()-.5)*2.4,vy:(r()-.5)*1.7,va:(r()-.5)*.13});
  for(let i=0;i<170;i++)st.fine.push({x:(r()-.5)*58,y:(r()-.5)*32,s:.7+r()*1.7,vx:(r()-.5)*3.4,vy:(r()-.5)*2.6});
  st.cracks=[];for(let i=0;i<9;i++){const p=[[(r()-.5)*20,(r()-.5)*14]];for(let k=0;k<5;k++)p.push([p[k][0]+(r()-.5)*22,p[k][1]+(r()-.5)*16]);st.cracks.push(p)}
 },
 draw(st,T){const x=st.ctx,W=st.w,H=st.h,dur=6.4,t=Math.min(1,T/dur);
  const panel=(cx,label,sub,mode)=>{
    const cy=H*0.47;
    x.save();x.translate(cx,cy);
    const close=clamp(t/0.26,0,1), broke=t>0.26, bt=clamp((t-0.26)/0.40,0,1);
    /* burr edges */
    const gap=lerp(46,mode?16:14,ease(close));
    x.strokeStyle=mode?'#626971':C.dim;x.lineWidth=2.5;x.lineJoin='round';
    const drawEdge=(sy,dir)=>{x.beginPath();
      if(mode){ /* blunt */ x.moveTo(dir*-74,sy);x.lineTo(dir*-16,sy);x.lineTo(dir*-16,sy+dir*10);x.lineTo(dir*-74,sy+dir*10);}
      else{ x.moveTo(dir*-74,sy);x.lineTo(dir*-22,sy);x.lineTo(dir*-6,sy+dir*7);}
      x.stroke()};
    drawEdge(-gap/2,1);
    x.save();x.rotate(Math.PI);drawEdge(-gap/2,1);x.restore();
    if(!broke){
      x.fillStyle='#B9865A';x.strokeStyle='#8A6440';x.lineWidth=1.5;
      rr(x,-32,-19,64,38,7);x.fill();x.stroke();
      if(mode&&close>.6){x.strokeStyle='rgba(255,255,255,.55)';x.lineWidth=1;
        st.cracks.forEach(p=>{const n=clamp((close-.6)/.4,0,1)*p.length;x.beginPath();x.moveTo(p[0][0],p[0][1]);
          for(let i=1;i<n;i++)x.lineTo(p[i][0],p[i][1]);x.stroke()})}
    } else {
      const g=easeOut(bt);
      if(!mode){
        [[-1,-1],[1,1]].forEach((d,i)=>{x.save();x.translate(d[0]*g*26,d[1]*g*9);x.rotate(d[0]*g*0.16);
          x.fillStyle='#B9865A';x.strokeStyle='#8A6440';x.lineWidth=1.5;rr(x,-31,i?-1:-19,62,20,6);x.fill();x.stroke();x.restore()});
        for(let i=0;i<5;i++){const f=st.fine[i];x.fillStyle='rgba(233,215,190,.85)';
          x.beginPath();x.arc(f.x+f.vx*g*16,f.y+f.vy*g*13,f.s,0,6.3);x.fill()}
      } else {
        st.frag.forEach(f=>{x.save();x.translate(f.x+f.vx*g*17,f.y+f.vy*g*15);x.rotate(f.a+f.va*g*20);
          x.fillStyle='#B9865A';x.strokeStyle='#8A6440';x.lineWidth=1;rr(x,-f.s/2,-f.s/2.4,f.s,f.s/1.2,2);x.fill();x.stroke();x.restore()});
        st.fine.forEach(f=>{x.globalAlpha=.9;x.fillStyle='#E9D7BE';
          x.beginPath();x.arc(f.x+f.vx*g*19,f.y+f.vy*g*16,f.s,0,6.3);x.fill()});x.globalAlpha=1;
      }
    }
    x.restore();
    txt(x,label,[cx,H*0.14],14,mode?C.red:C.teal,'center',700);
    txt(x,sub,[cx,H*0.14+18],11.5,C.dim,'center',500);
    /* fines meter */
    const mw=Math.min(124,W*0.36), mx=cx-mw/2, my=H-42;
    x.fillStyle=C.line;rr(x,mx,my,mw,6,3);x.fill();
    const amt=broke?(mode?1:0.045):0;
    x.fillStyle=mode?C.red:C.teal;rr(x,mx,my,Math.max(3,mw*amt*easeOut(bt)),6,3);x.fill();
    txt(x,TT('fig.fines_produced'),[cx,my-9],10.5,C.dim,'center',600);
  };
  const NAR=W<470;
  panel(W*0.27,TT('fig.cutting'),NAR?TT('fig.sharp_short'):TT('fig.sharp'),0);
  panel(W*0.73,TT('fig.crushing'),NAR?TT('fig.blunt_short'):TT('fig.blunt'),1);
  x.strokeStyle=C.line;x.lineWidth=1;x.beginPath();x.moveTo(W/2,26);x.lineTo(W/2,H-24);x.stroke();
 }});



A('burr',{
 init(st){st.xs=[];for(let i=0;i<=280;i++)st.xs.push(lerp(-1,0.35,i/280))},
 draw(st,T){const x=st.ctx,W=st.w,H=st.h,dur=8,t=Math.min(1,T/dur);
  const s=lerp(3,7.5,(Math.sin((t*2-0.5)*Math.PI)+1)/2);
  const mainMu=Math.log10(0.30+0.098*s), fineMu=Math.log10(0.145), fineW=clamp(0.78-0.055*(s-3),0.35,0.9);
  const base=psdCount(st.xs,fineW,mainMu,fineMu);
  const cntA=unitArea(st.xs,base), volA=unitArea(st.xs,weightBy(st.xs,base,2.35));
  const M5=Math.max(Math.max(...cntA),Math.max(...volA));
  const cnt=cntA.map(v=>v/M5), vol=volA.map(v=>v/M5);
  const gx=54,gy=52,gw=W-gx-26,gh=H-124;
  x.strokeStyle=C.line;x.lineWidth=1;x.beginPath();x.moveTo(gx,gy);x.lineTo(gx,gy+gh);x.lineTo(gx+gw,gy+gh);x.stroke();
  const lo=-1,hi=0.35,px=v=>gx+(v-lo)/(hi-lo)*gw,py=v=>gy+gh-v*gh*0.9;
  [0.1,0.2,0.5,1.0,2.0].forEach(d=>{const L=Math.log10(d);if(L<lo||L>hi)return;
    x.strokeStyle='#22282E';x.beginPath();x.moveTo(px(L),gy);x.lineTo(px(L),gy+gh);x.stroke();
    txt(x,d+'',[px(L),gy+gh+15],10.5,C.dim,'center',500)});
  txt(x,TT('fig.diameter'),[gx+gw/2,gy+gh+31],11,C.dim,'center',600);
  /* pinned fines line */
  x.strokeStyle='rgba(254,215,102,.55)';x.lineWidth=1.6;x.setLineDash([5,4]);
  x.beginPath();x.moveTo(px(fineMu),gy-6);x.lineTo(px(fineMu),gy+gh);x.stroke();x.setLineDash([]);
  txt(x,TT('fig.fines_peak'),[px(fineMu)+7,gy+8],10.5,C.yellow,'left',700);
  /* curves */
  x.strokeStyle='#8F949D';x.lineWidth=1.8;x.setLineDash([5,4]);x.beginPath();
  st.xs.forEach((v,k)=>{const X=px(v),Y=py(cnt[k]);k?x.lineTo(X,Y):x.moveTo(X,Y)});x.stroke();x.setLineDash([]);
  x.strokeStyle=C.teal;x.lineWidth=2.8;x.beginPath();
  st.xs.forEach((v,k)=>{const X=px(v),Y=py(vol[k]);k?x.lineTo(X,Y):x.moveTo(X,Y)});x.stroke();
  x.globalAlpha=.12;x.fillStyle=C.teal;x.lineTo(px(hi),gy+gh);x.lineTo(px(lo),gy+gh);x.closePath();x.fill();x.globalAlpha=1;
  /* moving coarse marker */
  let bi=0;vol.forEach((v,i)=>{if(v>vol[bi])bi=i});
  x.fillStyle=C.teal;x.beginPath();x.arc(px(st.xs[bi]),py(vol[bi])-11,4,0,6.3);x.fill();
  x.beginPath();x.moveTo(px(st.xs[bi]),py(vol[bi])-5);x.lineTo(px(st.xs[bi])-4,py(vol[bi])-11);x.lineTo(px(st.xs[bi])+4,py(vol[bi])-11);x.closePath();x.fill();
  /* readout */
  if(W<470){
    txt(x,TF('fig.setting',s.toFixed(1)),[gx,24],14,C.ink,'left',800);
    txt(x,TF('fig.coarse_peak',Math.pow(10,st.xs[bi]).toFixed(2)),[gx+gw,24],11.5,C.teal,'right',700);
  } else {
    txt(x,TT('fig.burr_spacing'),[gx,26],11,C.dim,'left',600);
    txt(x,TF('fig.setting',s.toFixed(1)),[gx+86,26],15,C.ink,'left',800);
    txt(x,TF('fig.coarse_peak',Math.pow(10,st.xs[bi]).toFixed(2)),[gx+gw,26],12.5,C.teal,'right',700);
  }
  /* slider */
  const sx=gx,sw=gw,sy=H-26;
  x.strokeStyle=C.line;x.lineWidth=3;x.beginPath();x.moveTo(sx,sy);x.lineTo(sx+sw,sy);x.stroke();
  x.fillStyle=C.teal;x.beginPath();x.arc(sx+sw*(s-3)/4.5,sy,5,0,6.3);x.fill();
  txt(x,TT('fig.fine'),[sx,sy-11],10,C.dim,'left',500);txt(x,TT('fig.coarse'),[sx+sw,sy-11],10,C.dim,'right',500);
  txt(x,TT('fig.by_count'),[W<470?gx:gx+gw,44],10.5,'#8F949D',W<470?'left':'right',600);
 }});


const RUN={fines:7.0,burr:8.4}, ctl={};
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
document.querySelectorAll('.rss canvas[data-anim]').forEach(cv=>{
  const id=cv.dataset.anim, d=anims[id]; if(!d) return;
  const st={cv,ctx:cv.getContext('2d'),w:0,h:0}; let raf=null, started=false, lastW=0;
  function size(){const r=cv.getBoundingClientRect(),dpr=Math.min(2,devicePixelRatio||1);
    st.w=Math.max(280,Math.round(r.width||cv.parentNode.clientWidth)); lastW=st.w; st.h=+cv.dataset.h;
    cv.style.height=st.h+'px'; cv.width=st.w*dpr; cv.height=st.h*dpr; st.ctx.setTransform(dpr,0,0,dpr,0,0); if(d.init)d.init(st);}
  const frame=T=>{st.ctx.clearRect(0,0,st.w,st.h); try{d.draw(st,T)}catch(e){console.error(e)}};
  function play(){ if(raf)cancelAnimationFrame(raf); size(); started=true;
    if(reduce){frame(RUN[id]);return;}
    const t0=performance.now(); const step=now=>{const t=Math.min(RUN[id],(now-t0)/1000); frame(t); raf=t<RUN[id]?requestAnimationFrame(step):null;}; raf=requestAnimationFrame(step);}
  function settle(){ if(raf)cancelAnimationFrame(raf),raf=null; size(); frame(RUN[id]); }
  ctl[id]={play,settle};
  size(); frame(RUN[id]);  /* complete at rest */
  addEventListener('resize',()=>{const w=Math.round(cv.getBoundingClientRect().width); if(w&&w!==lastW){ if(raf) size(); else settle(); }});
  let seen=false;
  new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting&&!seen){seen=true;play();} }),{threshold:.3}).observe(cv);
});
document.querySelectorAll('.rss [data-replay]').forEach(b=>b.addEventListener('click',()=>ctl[b.dataset.replay]&&ctl[b.dataset.replay].play()));
window.rssReplay=id=>ctl[id]&&ctl[id].play();
})();
